import React, {useRef} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Popper from '@mui/material/Popper';

import LookContextMenuContent from "./lookContextMenuContent";
import {setLookContextMenu} from "../../../actions/lookFunctions";
import {ALL_CONTEXT_MENU} from "../core/constants";
import WithZoomToFeature from "../hocs/withZoomToFeature";

const LookContextMenu = (props) => {

  const {contextMenu, setLookContextMenu, imageCanvas, isMobile} = props;
  const {opened, position} = contextMenu;
  const anchorRef = useRef(null);

  const handleClose = (event) => {
    if (document.hoveredLayer && event.target.closest(".canvas") && ALL_CONTEXT_MENU.includes(document.hoveredLayer.partId)) {
      return
    }
    setLookContextMenu({
      opened: false,
      layerPosition: "",
    });
  };

  const styles = {
    left: position.x,
    top: position.y,
  }

  return (
    <div style={styles} className="look-context" ref={anchorRef}>
      <Popper open={opened}
              className={"look-context__canvas"}
              anchorEl={anchorRef.current}
              placement={"bottom-start"}
              transition
              disablePortal={!isMobile}
              modifiers={[{
                name: 'preventOverflow',
                enabled: true,
                options: {
                  altAxis: true,
                  altBoundary: true,
                  tether: true,
                  rootBoundary: 'viewport',
                  padding: 8,
                },
              },]}>
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: "left top" }}
          >
            <div className="look-context__popper-content">
              <WithZoomToFeature imageCanvas={imageCanvas}>
                {(zoomToFeatureGroup) => (
                  <ClickAwayListener onClickAway={handleClose}>
                    <div className="look-context__popper-content">
                      <LookContextMenuContent zoomToFeatureGroup={zoomToFeatureGroup} />
                    </div>
                  </ClickAwayListener>
                )}
              </WithZoomToFeature>
            </div>
          </Grow>
        )}
      </Popper>
    </div>
  )
};

LookContextMenu.propTypes = {
  imageCanvas: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ])
}

const mapStateToProps = (store) => {
  const {contextMenu} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    contextMenu,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookContextMenu
};

export default connect(mapStateToProps, mapDispatchToProps)(LookContextMenu)
